import { render, staticRenderFns } from "./item_description.vue?vue&type=template&id=7d8a02d4&scoped=true&"
import script from "./item_description.vue?vue&type=script&lang=js&"
export * from "./item_description.vue?vue&type=script&lang=js&"
import style0 from "./item_description.vue?vue&type=style&index=0&id=7d8a02d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8a02d4",
  null
  
)

export default component.exports